/* BaseLogsViewComponent.js */

'use strict';

const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");

class BaseLogsViewComponent extends EventEmitter {
    constructor(storageFactory) {
        super();
        this._storageFactory = storageFactory;
        this._logPreferencesKey = 'otherSolutions';
        this._dataStorage = null;
        this._loadLogPreferences();
    }

    _loadLogPreferences() {
        return this._storageFactory.loadUserPreferences()
            .then(() => {
                this._dataStorage = this._storageFactory.getRemoteStorageInstance("user", "logs");
                this.emit('LogLevels', this.getLogLevels());
                this.emit('LogSequence', this.getLogSequence());
                this.emit('ScrollLock', this.getScrollLock());
                return Promise.resolve();
            });
    }

    _getLogPreferences() {
        if(this._dataStorage) {
            let preferences = this._dataStorage.getData(this._logPreferencesKey, true);
            if(!preferences) {
                preferences = {logLevels: {}, logSequence: 'log_event_number'};
                this._dataStorage.setData(preferences, this._logPreferencesKey);
            }
            return preferences;
        } else {
            return undefined;
        }
    }
    /*******************************************/
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    shutdown() {
        let shutdownProm = this._dataStorage ? this._dataStorage.shutdown() : Promise.resolve();
        return shutdownProm.then(() => {
            this._dataStorage = undefined;
            this._storageFactory = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _updateLogLevelPreferences(logLevels) {
        this.setLogLevels(logLevels);
    }

    _updateLogSequencePreference(logSequence) {
        this.setLogSequence(logSequence);
    }

    _updateScrollLockPreference(scrollLock) {
        this.setScrollLock(scrollLock);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    get logLevels(){
        return this.getLogLevels();
    }

    getLogLevels() {
        return _.get(this._getLogPreferences(), 'logLevels', {});
    }

    set logLevels(logLevels) {
        return this.setLogLevels(logLevels);
    }

    setLogLevels(logLevels) {
        if(!this._dataStorage) {
            this._logger.error('Failed to save logLevels preferences to remote storage');
        }
        let data = this._getLogPreferences();
        data.logLevels = logLevels;
        this._dataStorage.setData(data, this._logPreferencesKey);
    }

    get logSequence() {
        return this.getLogSequence();
    }

    getLogSequence() {
        return _.get(this._getLogPreferences(), 'logSequence', 'log_event_number');
    }

    set logSequence(logSequence) {
        this.setLogSequence(logSequence);
    }

    setLogSequence(logSequence) {
        if(!this._dataStorage) {
            this._logger.error('Failed to save logSequence preferences to remote storage');
        }
        let data = this._getLogPreferences();
        data.logSequence = logSequence;
        this._dataStorage.setData(data, this._logPreferencesKey);
    }

    get scrollLock() {
        return this.getScrollLock();
    }

    getScrollLock() {
        return _.get(this._getLogPreferences(), 'scrollLock', false);
    }

    set scrollLock(scrollLock) {
        return this.setScrollLock(scrollLock);
    }

    setScrollLock(scrollLock) {
        if(!this._dataStorage) {
            this._logger.error('Failed to save scrollLock preferences to remote storage');
        }
        let data = this._getLogPreferences();
        data.scrollLock = scrollLock;
        this._dataStorage.setData(data, this._logPreferencesKey);
    }
}

module.exports = BaseLogsViewComponent;
